import { Box, Toolbar } from '@mui/material';
import React from 'react';
import Loader, { LoadingStage } from './Loader';
import SiteHeader from './SiteHeader/SiteHeader';

interface AppShellLoaderProps {
  stage: LoadingStage;
}

const AppShellLoader: React.FunctionComponent<React.PropsWithChildren<AppShellLoaderProps>> = ({ stage }) => {
  return (
    <Box display="flex" flexDirection="column" minHeight="100%">
      <SiteHeader />
      <Toolbar />
      <Box display="flex" flex={1} alignItems="center" justifyContent="center">
        <Loader stage={stage} />
      </Box>
    </Box>
  );
};

export default AppShellLoader;
